import React, { useEffect, useState } from "react";
import {
  DELETE_TABLE_DATA_ERROR,
  DELETE_TABLE_DATA_SUCCESS,
  FETCH_PERMISSION_SEARCH_SUCCESS,
  FETCH_PERMISSION_TABLE_ERROR,
  FETCH_PERMISSION_TABLE_SUCCESS,
  UPDATE_TABLE_DATA_ERROR,
  UPDATE_TABLE_DATA_SUCCESS,
} from "../../store/types/manageDataTypes";
import {
  API_METHOD_GET,
  API_METHOD_POST,
  API_METHOD_PUT,
  ENTITY_STATUS,
  PERMISSION_TYPES,
} from "../../config/constants";
import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import {
  Box,
  Grid,
  Icon,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import Swal from "sweetalert2";
import { theme } from "../../config/theme";
import { setManageDataReducer } from "../../store/actions/manageDataAction";
import AssignRolesModal from "./AssignRolesModal";
import CoreButton from "../../core/inputs/CoreButton";
import MasterDataEditModal from "./MasterDataEditModal";
import AddRoleAndPermission from "./AddRoleAndPermission";

const columns = [
  "id",
  "name",
  "label",
  "type",
  "link",
  "icon",
  "_status",
  "parentId",
];

export default function ManagePermissions() {
  const dispatch = useDispatch();

  const permissionTable = useSelector(
    (state) => state?.manageData?.permissionTable,
  );

  const insertTableDataSuccess = useSelector(
    (state) => state?.manageData?.insertTableDataSuccess,
  );
  const insertTableDataError = useSelector(
    (state) => state?.manageData?.insertTableDataError,
  );
  const insertTableDataMsg = useSelector(
    (state) => state?.manageData?.insertTableDataMsg,
  );

  const updateTableDataSuccess = useSelector(
    (state) => state?.manageData?.updateTableDataSuccess,
  );
  const updateTableDataError = useSelector(
    (state) => state?.manageData?.updateTableDataError,
  );
  const updateTableDataMsg = useSelector(
    (state) => state?.manageData?.updateTableDataMsg,
  );

  const deleteTableDataSuccess = useSelector(
    (state) => state?.manageData?.deleteTableDataSuccess,
  );
  const deleteTableDataError = useSelector(
    (state) => state?.manageData?.deleteTableDataError,
  );
  const deleteTableDataMsg = useSelector(
    (state) => state?.manageData?.deleteTableDataMsg,
  );

  const [editItemDetail, setEditItemDetail] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAssignRoleModal, setShowAssignRoleModal] = useState(false);
  const [permission, setPermission] = useState(false);

  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {
    if (insertTableDataSuccess) {
      setShowAddModal(false);
      dispatch(setManageDataReducer({ insertTableDataSuccess: false }));
      getPermissions();
      Swal.fire({
        title: "Success",
        text: insertTableDataMsg,
        icon: "success",
        confirmButtonColor: theme.palette.primary.main,
      });
    }
    if (insertTableDataError) {
      dispatch(setManageDataReducer({ insertTableDataError: false }));
      Swal.fire({
        title: "Oops!",
        text: insertTableDataMsg,
        icon: "error",
        confirmButtonColor: theme.palette.primary.main,
      });
    }
  }, [insertTableDataSuccess, insertTableDataError]);

  useEffect(() => {
    if (updateTableDataSuccess) {
      setShowEditModal(false);
      dispatch(setManageDataReducer({ updateTableDataSuccess: false }));
      getPermissions();
    }
    if (updateTableDataError) {
      setShowEditModal(false);
      Swal.fire({
        title: "Error",
        text: updateTableDataMsg,
        icon: "error",
        confirmButtonColor: theme.palette.primary.main,
      });
      dispatch(setManageDataReducer({ updateTableDataError: false }));
    }
  }, [updateTableDataSuccess, updateTableDataError]);

  useEffect(() => {
    if (deleteTableDataSuccess) {
      dispatch(setManageDataReducer({ deleteTableDataSuccess: false }));
      Swal.fire({
        title: "Success",
        text: deleteTableDataMsg,
        icon: "success",
        confirmButtonColor: theme.palette.primary.main,
      });
      getPermissions();
    }
    if (deleteTableDataError) {
      dispatch(setManageDataReducer({ deleteTableDataError: false }));
      Swal.fire({
        title: "Oops!",
        text: deleteTableDataMsg,
        icon: "error",
        confirmButtonColor: theme.palette.primary.main,
      });
    }
  }, [deleteTableDataSuccess, deleteTableDataError]);

  const getPermissions = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/data/Permissions",
        null,
        null,
        null,
        FETCH_PERMISSION_TABLE_SUCCESS,
        FETCH_PERMISSION_TABLE_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  const onEdit = (value) => {
    dispatch(
      api_request(
        API_METHOD_PUT,
        `/data/Permissions/${editItemDetail.id}/update`,
        { [editItemDetail.col]: value },
        null,
        null,
        UPDATE_TABLE_DATA_SUCCESS,
        UPDATE_TABLE_DATA_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  const onDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "If you proceed, the item will be permanently deleted from the database. If you prefer a soft delete, please update its _status field to 'delete' instead.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: theme.palette.primary.main,
      cancelButtonColor: theme.palette.error.main,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          api_request(
            API_METHOD_POST,
            "/data/Permissions/delete",
            { tableIds: [id] },
            null,
            null,
            DELETE_TABLE_DATA_SUCCESS,
            DELETE_TABLE_DATA_ERROR,
            true,
            false,
            true,
          ),
        );
      }
    });
  };

  return (
    <Box style={{ width: "100%" }}>
      <Box style={{ padding: "16px" }}>
        <AssignRolesModal
          show={showAssignRoleModal}
          onClose={() => {
            setShowAssignRoleModal(false);
          }}
          permission={permission}
        />
        <AddRoleAndPermission
          show={showAddModal}
          onClose={() => {
            setShowAddModal(false);
          }}
          table="Permissions"
        />
        <MasterDataEditModal
          show={showEditModal}
          col={editItemDetail?.col}
          asyncSelectDetail={{
            display: (item) => {
              return { value: item.id, label: item.name };
            },
            valueColumn: "id",
            reducerVar: "fetchPermissionSearchResults",
            apiPath: "/data/Permissions",
            query: {},
            loadType: null,
            successType: FETCH_PERMISSION_SEARCH_SUCCESS,
            errorType: null,
            loading: true,
          }}
          value={
            editItemDetail &&
            permissionTable?.find((f) => f.id === editItemDetail?.id) &&
            permissionTable?.find((f) => f.id === editItemDetail?.id)[
              editItemDetail?.col
            ]
          }
          options={
            editItemDetail?.col === "_status"
              ? Object.keys(ENTITY_STATUS).map((item) => {
                  return {
                    value: ENTITY_STATUS[item],
                    label: ENTITY_STATUS[item],
                  };
                })
              : editItemDetail?.col === "type"
                ? Object.keys(PERMISSION_TYPES).map((item) => {
                    return {
                      value: PERMISSION_TYPES[item],
                      label: PERMISSION_TYPES[item],
                    };
                  })
                : []
          }
          onClose={() => {
            setShowEditModal(false);
          }}
          onSubmit={onEdit}
        />
        <Grid container>
          <Grid item xs={4}>
            <CoreButton
              onClick={() => {
                setShowAddModal(true);
              }}
            >
              Add Permission
            </CoreButton>
          </Grid>
          <Grid item xs={12}>
            <TableContainer style={{ height: "70vh" }}>
              <Paper
                elevation={3}
                sx={{ display: "inline-block", marginTop: "12px" }}
              >
                {permissionTable && (
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ textAlign: "center" }}>
                          Action
                        </TableCell>
                        {columns
                          // .sort((a, b) => (a > b ? 1 : -1))
                          .map((item, index) => (
                            <TableCell key={index}>{item}</TableCell>
                          ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {[...permissionTable]
                        .sort((a, b) => (a?.id > b?.id ? 1 : -1))
                        .map((item) => (
                          <TableRow key={item.id}>
                            <TableCell style={{ textAlign: "center" }}>
                              <Box display="flex" gap={1}>
                                <Tooltip title="Delete">
                                  <CoreIconButton
                                    size="small"
                                    color="error"
                                    onClick={() => {
                                      onDelete(item.id);
                                    }}
                                  >
                                    <Icon style={{ fontSize: "20px" }}>
                                      delete
                                    </Icon>
                                  </CoreIconButton>
                                </Tooltip>
                                <Tooltip title="Assign Roles">
                                  <CoreIconButton
                                    size="small"
                                    color="secondery"
                                    onClick={() => {
                                      setPermission(item);
                                      setShowAssignRoleModal(true);
                                    }}
                                  >
                                    <Icon style={{ fontSize: "20px" }}>
                                      edit
                                    </Icon>
                                  </CoreIconButton>
                                </Tooltip>
                              </Box>
                            </TableCell>
                            {columns.map((col, colIndex) => (
                              <TableCell
                                key={item.id + colIndex}
                                sx={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: 200, // set a max width as needed
                                }}
                                onClick={() => {
                                  if (col !== "id") {
                                    setEditItemDetail({
                                      id: item.id,
                                      col: col,
                                    });
                                    setShowEditModal(true);
                                  }
                                }}
                              >
                                {typeof item[col] !== "object"
                                  ? item[col]
                                  : JSON.stringify(item[col])}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                )}
              </Paper>
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
